// components/TableShimmer.jsx
import React from "react";
import "./index.css";

const TableShimmer = ({ theme = "dark", centered = false }) => {
  const isDark = theme === "dark";
  return (
    <div className={`dashboard-skeleton ${isDark ? "dark" : "light"} ${centered ? "shimmer-centered" : ""}`}>
      <div className="row mb-4">
        <div className="col-md-12">
          <div className="card shimmer-card-tab-Table p-6">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <div className="shimmer-block h-4 w-20 mb-1"></div>
            </div>
            {Array.from({ length: centered ? 1 :10 }).map((_, i) => (
              <div key={i} className="d-flex align-items-center  mb-4">
                <div className="shimmer-circle me-3"></div>
                <div className="flex-grow-1">
                  <div className="shimmer-block h-4 w-75 mb-2"></div>
                </div>
                <div className="flex-grow-1">
                  <div className="shimmer-block h-4 w-75 mb-2"></div>
                </div>
                <div className="flex-grow-1">
                  <div className="shimmer-block h-4 w-75 mb-2"></div>
                </div>
                <div className="flex-grow-1">
                  <div className="shimmer-block h-4 w-75 mb-2"></div>
                </div>
                <div className="flex-grow-1">
                  <div className="shimmer-block h-4 w-75 mb-2"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableShimmer;
